import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

export const removeNullsInterceptor: HttpInterceptorFn = (req, next) => {
  if (!shouldProcessRequest(req)) {
    return next(req);
  }

  const cleanedBody = removeNulls(req.body);
  return next(req.clone({ body: cleanedBody }));
};

function shouldProcessRequest(request: HttpRequest<any>): boolean {
  return (
    request.url.includes(environment.apiUrl) &&
    request.body &&
    typeof request.body === 'object'
  );
}

function removeNulls(payload: any): any {
  if (typeof payload !== 'object' || payload === null) {
    return payload; // Return non-object values as-is
  }

  if (Array.isArray(payload)) {
    // Clean and filter null/undefined values from arrays
    return payload
      .filter((item) => item !== null && item !== undefined) // Remove null/undefined
      .map((item) => removeNulls(item)); // Recursively clean array items
  }

  // Clean object properties
  return Object.keys(payload).reduce(
    (acc, key) => {
      const value = payload[key];
      if (value !== null && value !== undefined) {
        acc[key] = removeNulls(value);
      }
      return acc;
    },
    {} as Record<string, any>,
  );
}
